{
  "businessUnit": {
    "list": {
      "deviceCount": "{count} equipos|{count} equipo|{count} equipos"
    },
    "settings": {
      "description": {
        "information": "Información",
        "title": "Información"
      },
      "button": "Ajustes",
      "users": {
        "title": "Usuarios"
      },
      "firmwares": {
        "title": "Firmware"
      },
      "logs": {
        "title": "Registros"
      }
    },
    "name": "Nombre de la unidad de negocio",
    "addOrganization": {
      "button": "Añadir una organización"
    },
    "leave": {
      "title": "Editar la unidad de negocio"
    }
  },
  "entityLocation": {
    "location": "Lugar",
    "country": "País",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "timezone": "Zona horaria",
    "countryError": "El país es obligatorio.",
    "latitudeError": "La latitud debe estar entre -90 y 90.",
    "longitudeError": "La longitud debe estar entre -180 y 180.",
    "timezoneError": "La zona horaria es obligatoria.",
    "countryPlaceholder": "Elegir el país",
    "countrySearchPlaceholder": "Buscar por nombre de país",
    "countryPopular": "Popular"
  },
  "superAdministration": {
    "settings": {
      "title": "Modificar {name}",
      "information": {
        "title": "Información",
        "subtitle": "Nombre de la organización",
        "nameLabel": "Nombre"
      },
      "button": "Ajustes",
      "users": {
        "title": "Usuarios"
      },
      "pki": {
        "title": "PKI",
        "newConnection": "Nueva conexión"
      },
      "logs": {
        "title": "Registros"
      }
    }
  },
  "organization": {
    "create": {
      "title": "Creación de la organización",
      "saveButton": "Crear la organización"
    },
    "information": {
      "title": "Información de la organización"
    },
    "name": "Nombre de la organización",
    "type": {
      "label": "Tipo",
      "placeholder": "Seleccionar tipo",
      "operator": "Organización del operador",
      "administration": "Organización de administración"
    },
    "nameRequiredError": "El nombre es obligatorio.",
    "typeError": "El tipo es obligatorio.",
    "nameLengthError": "Longitud entre {min} y {max} caracteres.",
    "settings": {
      "information": {
        "title": "Información"
      },
      "description": {
        "title": "Descripción"
      },
      "users": {
        "title": "Usuarios"
      },
      "operationButton": "Funcionamiento",
      "logs": {
        "title": "Registros"
      },
      "license": {
        "title": "Gestión de la licencia"
      }
    },
    "leave": {
      "title": "Editar la organización",
      "message": "Se perderán todos los datos no guardados."
    }
  },
  "entityAdmin": {
    "lastname": "Apellidos del administrador",
    "title": "Información del administrador",
    "firstname": "Nombre del administrador",
    "login": "Inicio de sesión de administrador",
    "email": "Correo electrónico del administrador",
    "language": "Idioma"
  },
  "country": {
    "GRC": "Grecia",
    "MOZ": "Mozambique",
    "FRA": "Francia",
    "MUS": "Mauricio",
    "BWA": "Botsuana",
    "CAF": "República Centroafricana",
    "FIN": "Finlandia",
    "KAZ": "Kazajistán",
    "MHL": "Islas Marshall",
    "MNE": "Montenegro",
    "MYS": "Malasia",
    "NPL": "Nepal",
    "NZL": "Nueva Zelanda",
    "PER": "Perú",
    "USA": "Estados Unidos de América",
    "YEM": "Yemen",
    "CMR": "Camerún",
    "CUB": "Cuba",
    "DOM": "República Dominicana",
    "ITA": "Italia",
    "LBR": "Liberia",
    "SWE": "Suecia",
    "TUN": "Túnez",
    "WSM": "Samoa",
    "CUW": "Curazao",
    "DNK": "Dinamarca",
    "IDN": "Indonesia",
    "SGP": "Singapur",
    "SLV": "El Salvador",
    "UGA": "Uganda",
    "URY": "Uruguay",
    "VEN": "Venezuela (República Bolivariana de)",
    "DEU": "Alemania",
    "GUM": "Guam",
    "MKD": "Macedonia (la antigua República Yugoslava de)",
    "MWI": "Malawi",
    "PAK": "Pakistán",
    "PRT": "Portugal",
    "BEL": "Bélgica",
    "BOL": "Bolivia (Estado Plurinacional de)",
    "COM": "Comoras",
    "CHE": "Suiza",
    "GHA": "Ghana",
    "IRN": "Irán (República Islámica de)",
    "IRQ": "Irak",
    "JAM": "Jamaica",
    "NLD": "Países Bajos",
    "POL": "Polonia",
    "VAT": "Ciudad del Vaticano",
    "AFG": "Afganistán",
    "DZA": "Argelia",
    "HKG": "Hong Kong",
    "LAO": "República Democrática Popular Lao",
    "NRU": "Nauru",
    "TKM": "Turkmenistán",
    "ZMB": "Zambia",
    "AUS": "Australia",
    "BHS": "Bahamas",
    "BIH": "Bosnia y Herzegovina",
    "CZE": "República Checa",
    "KOR": "Corea (República de)",
    "PHL": "Filipinas",
    "VCT": "San Vicente y las Granadinas",
    "ARM": "Armenia",
    "AZE": "Azerbaiyán",
    "BDI": "Burundi",
    "BGD": "Bangladesh",
    "ECU": "Ecuador",
    "ETH": "Etiopía",
    "GAB": "Gabón",
    "GMB": "Gambia",
    "HTI": "Haití",
    "KIR": "Kiribati",
    "MAC": "Macao",
    "MMR": "Birmania",
    "PRI": "Puerto Rico",
    "QAT": "Catar",
    "SVK": "Eslovaquia",
    "TGO": "Togo",
    "UKR": "Ucrania",
    "CAN": "Canadá",
    "MLI": "Malí",
    "MNP": "Islas Marianas del Norte",
    "SDN": "Sudán",
    "BRB": "Barbados",
    "FJI": "Fiyi",
    "KGZ": "Kirguistán",
    "MAF": "San Martín (parte francesa)",
    "MRT": "Mauritania",
    "ZWE": "Zimbabue",
    "CA-QC": "Quebec",
    "CHL": "Chile",
    "HRV": "Croacia",
    "SAU": "Arabia Saudita",
    "ASM": "Samoa Americana",
    "BMU": "Islas Bermudas",
    "COD": "Congo (República Democrática del)",
    "CRI": "Costa Rica",
    "GIN": "Guinea",
    "IMN": "Isla de Man",
    "JPN": "Japón",
    "SLB": "Islas Salomón",
    "SMR": "San Marino",
    "SUR": "Surinam",
    "TCA": "Islas Turcas y Caicos",
    "ATG": "Antigua y Barbuda",
    "COG": "Congo",
    "HND": "Honduras",
    "KNA": "San Cristóbal y Nieves",
    "ROU": "Rumanía",
    "STP": "Santo Tomé y Príncipe",
    "ZAF": "Sudáfrica",
    "BGR": "Bulgaria",
    "BRN": "Brunéi Darussalam",
    "CYP": "Chipre",
    "FSM": "Micronesia (Estados Federados de)",
    "MAR": "Marruecos",
    "MDA": "Moldavia (República de)",
    "MDG": "Madagascar",
    "MNG": "Mongolia",
    "SLE": "Sierra Leona",
    "TLS": "Timor Oriental",
    "VNM": "Vietnam",
    "AGO": "Angola",
    "BLZ": "Belice",
    "HUN": "Hungría",
    "IRL": "Irlanda",
    "KWT": "Kuwait",
    "MDV": "Maldivas",
    "NER": "Níger",
    "NIC": "Nicaragua",
    "PSE": "Palestina",
    "TWN": "Taiwán",
    "ARG": "Argentina",
    "COL": "Colombia",
    "JOR": "Jordania",
    "NAM": "Namibia",
    "SRB": "Serbia",
    "TJK": "Tayikistán",
    "CPV": "Cabo Verde",
    "GEO": "Georgia",
    "KOS": "República de Kosovo",
    "LUX": "Luxemburgo",
    "OMN": "Omán",
    "RUS": "Federación Rusa",
    "SOM": "Somalia",
    "SYC": "Seychelles",
    "TCD": "Chad",
    "TUV": "Tuvalu",
    "AND": "Andorra",
    "BHR": "Baréin",
    "BRA": "Brasil",
    "DJI": "Yibuti",
    "DMA": "Dominica",
    "EST": "Estonia",
    "ISR": "Israel",
    "MCO": "Mónaco",
    "MLT": "Malta",
    "SEN": "Senegal",
    "SXM": "Sint Maarten (parte neerlandesa)",
    "VUT": "Vanuatu",
    "ABW": "Aruba",
    "BEN": "Benín",
    "BLR": "Bielorrusia",
    "CYM": "Islas Caimán",
    "GIB": "Gibraltar",
    "GNB": "Guinea-Bissau",
    "GRD": "Granada",
    "IND": "India",
    "LBY": "Libia",
    "LCA": "Santa Lucía",
    "LVA": "Letonia",
    "PRK": "Corea (República Popular Democrática de)",
    "SSD": "Sudán del Sur",
    "TTO": "Trinidad y Tobago",
    "ALB": "Albania",
    "BTN": "Bután",
    "CIV": "Costa de Marfil",
    "LKA": "Sri Lanka",
    "PAN": "Panamá",
    "SYR": "República Árabe Siria",
    "UZB": "Uzbekistán",
    "AUT": "Austria",
    "EGY": "Egipto",
    "ERI": "Eritrea",
    "FRO": "Islas Feroe",
    "GNQ": "Guinea Ecuatorial",
    "GRL": "Groenlandia",
    "GUY": "Guayana",
    "LTU": "Lituania",
    "MEX": "México",
    "NOR": "Noruega",
    "RWA": "Ruanda",
    "SWZ": "Suazilandia",
    "THA": "Tailandia",
    "ARE": "Emiratos Árabes Unidos",
    "ESP": "España",
    "GBR": "Reino Unido de Gran Bretaña e Irlanda del Norte",
    "ISL": "Islandia",
    "KEN": "Kenia",
    "LSO": "Lesoto",
    "NGA": "Nigeria",
    "PLW": "Palaos",
    "PNG": "Papúa Nueva Guinea",
    "BFA": "Burkina Faso",
    "CHN": "China",
    "KHM": "Camboya",
    "LBN": "Líbano",
    "LIE": "Liechtenstein",
    "PRY": "Paraguay",
    "SVN": "Eslovenia",
    "TON": "Tonga",
    "TUR": "Turquía",
    "TZA": "Tanzania",
    "VGB": "Islas Vírgenes Británicas",
    "GTM": "Guatemala"
  },
  "relation": {
    "since": "Desde: {date}",
    "delete": {
      "confirm": {
        "title": "Suprimir la relación",
        "description": "¿Seguro que desea suprimir esta relación con {name}?"
      }
    }
  },
  "relations": {
    "affiliations": {
      "title": "Afiliación",
      "add": {
        "button": "Añadir una afiliación"
      },
      "parentEntity": {
        "title": "Entidad matriz"
      },
      "childrenEntities": {
        "title": "Entidades afiliadas"
      }
    },
    "delegations": {
      "title": "Delegación",
      "add": {
        "button": "Añadir una delegación"
      }
    },
    "title": "Relaciones",
    "add": {
      "createLink": "Crear un vínculo con una asociación existente",
      "createOrganization": "Crear una nueva organización"
    },
    "uploadIdCard": {
      "title": "Cargar la tarjeta de identificación de la organización",
      "validation": {
        "fileMandatory": "El archivo debe ser de tipo .JSON",
        "fileEmpty": "El archivo no debe estar vacío",
        "fileSize": "El tamaño del archivo debe ser inferior a 750 MB"
      }
    },
    "contact": {
      "administrator": "Administrador:",
      "noContact": "Ningún contacto identificado",
      "referentUser": {
        "title": "Contacto de la organización",
        "description": "Contacto designado para cuestiones operativas, de soporte o solicitudes comerciales relacionadas con esta organización.",
        "selectUser": "Seleccionar un usuario",
        "modified": "Modificar el contacto"
      }
    }
  }
}
